import {  toast } from "react-toastify";

const showToast = (
  message,
  type = "success"
) => {
  const position = "top-right";

  toast(message, {
    position,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    type: type,
  });
};

export const showSuccess = (message, title = null) => {
  showToast(message,"success");
};

export const showError = (message, title = null) => {
  showToast(message,"error");
};